import React from 'react'
import { CSSHandler, LabDataHandler } from 'utils'


class LabTab extends React.PureComponent {
	onCurrentChange = (labID, affiliatedID, affiliatedPath) => {
		const { lab, currentLabID, history } = this.props;

		if (labID !== currentLabID.toString()) {
			const masterLabID = LabDataHandler.getLabID(lab);

			let href = '/lab/dashboard/' + masterLabID;

			// affiliated
			if (masterLabID !== affiliatedID) { href = href + '/' + affiliatedPath; }
			
			history.push(href);
		}
	}

	onClick = (e) => {
		const { laboratoryId, affiliatedId, affiliatedPath } = e.currentTarget.dataset;

		this.onCurrentChange(laboratoryId, affiliatedId, affiliatedPath);
	}

	onTabLeftClick = (e) => {
		const currentTab = document.querySelector('.ua-tab-item.active');

		if (currentTab) {
			const prevItem = currentTab.previousSibling;

			if (prevItem) {
				const {
					laboratoryId,
					affiliatedId,
					affiliatedPath,
				} = prevItem.firstChild.dataset;

				this.onCurrentChange(laboratoryId, affiliatedId, affiliatedPath);
			}
		}
	}

	onTabRightClick = (e) => {
		const currentTab = document.querySelector('.ua-tab-item.active');

		if (currentTab) {
			const nextItem = currentTab.nextSibling;

			if (nextItem) {
				const {
					laboratoryId,
					affiliatedId,
					affiliatedPath,
				} = nextItem.firstChild.dataset;

				this.onCurrentChange(laboratoryId, affiliatedId, affiliatedPath);
			}
		}
	}

	handleResize = () => {
		CSSHandler.setTabCSS('lab_tab');
	}

	componentDidMount() {
		this.handleResize();

		window.addEventListener('resize', this.handleResize);
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.currentLabID !== this.props.currentLabID) {
			this.handleResize();
		}
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);
	}

	render() {
		const { lab, currentLabID } = this.props;

		let component = null;

		if (lab && lab.master && lab.master.affiliated_products.length) {
			const affiliatedProducts = lab.master.affiliated_products;

			component = (
				<div id='dashboard-tab-container' className='dashboard-tab-container'>
					<div
						className='tab-btn'
						onClick={this.onTabLeftClick}
					>
						<i className='fas fa-caret-left'/>
					</div>

					<ul id='ua-tab' className='ua-tab dashboard-tab'>
						<li	className={`ua-tab-item ${(lab.id === currentLabID) ? 'active' : ''}`}>
							<div
								className='ua-tab-title'
								data-laboratory-id={lab.id}
								data-affiliated-id={lab.id}
								data-affiliated-path={LabDataHandler.getLabID(lab)}
								onClick={this.onClick}
							>
								{(lab.alias && lab.alias !== '') ? lab.alias : lab.title}
							</div>
						</li>

						{affiliatedProducts.map((item, key) => {
							const laboratory = item.laboratory;
							const { id, alias, title } = laboratory;
							const isActive = id === currentLabID;
							const affiliatedPath = LabDataHandler.getLabID(laboratory);

							return (
								<li
									className={`ua-tab-item cursor-pointer ${isActive ? 'active' : ''}`}
									key={key}
								>
									<div
										className='ua-tab-title'
										data-laboratory-id={id}
										data-affiliated-id={id}
										data-affiliated-path={affiliatedPath}
										onClick={this.onClick}
									>
										{(alias && alias !== '') ? alias : title}
									</div>
								</li>
							);
						})}
					</ul>

					<div
						className='tab-btn margin-left-auto'
						onClick={this.onTabRightClick}
					>
						<i className='fas fa-caret-right'/>
					</div>
				</div>
			);
		}

		return component;
	}
}


export { LabTab }
